import { useMutation } from '@apollo/client';
import { LinkItemsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import type { LinkItemsTRPCInput } from './useLinkItemsTRPC';
import { useLinkItemsTRPC } from './useLinkItemsTRPC';

export const useLinkItems = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const [insertGraphQL, graphqlState] = useMutation(LinkItemsDocument, {
    update: (cache) => {
      evictField(cache, 'linked_item');
      evictField(cache, 'control');
      evictField(cache, 'action');
      evictField(cache, 'issue');
      evictField(cache, 'appetite');
      evictField(cache, 'risk');
    },
  });

  const trpcMutation = useLinkItemsTRPC();

  const linkItems = async (input: LinkItemsTRPCInput) => {
    if (trpcEnabled) {
      return trpcMutation.linkItems(input);
    }

    await insertGraphQL({
      variables: {
        Source: input.Source,
        Targets: input.Targets,
      },
    });
  };

  if (trpcEnabled) {
    return {
      linkItems,
      loading: trpcMutation.loading,
      error: trpcMutation.error,
    };
  }

  return {
    linkItems,
    loading: graphqlState.loading,
    error: graphqlState.error,
  };
};
